/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Sync_Changes_ButtonInputs */



/**
* | output |
* | --- |
* | "Sync Changes" |
*
* @param {Team_Sync_Sync_Changes_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_sync_changes_button = /** @type {((inputs?: Team_Sync_Sync_Changes_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Sync_Changes_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchroniser les modifications")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen synchronisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizza modifiche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменения синхронизации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizar cambios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("同步更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更を同期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिवर्तनों को सिंक्रनाइज़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronizar alterações")
	return /** @type {LocalizedString} */ ("Sync Changes")
});